import PropTypes from 'prop-types';
import { Cookies } from 'react-cookie';

export const customUomPropType = PropTypes.shape({
  length: PropTypes.shape({
    name: PropTypes.string,
    abbr: PropTypes.string.isRequired,
    symbol: PropTypes.string
  }),
  weight: PropTypes.shape({
    name: PropTypes.string,
    abbr: PropTypes.string.isRequired,
    symbol: PropTypes.string
  }),
  speed: PropTypes.shape({
    name: PropTypes.string,
    abbr: PropTypes.string.isRequired,
    symbol: PropTypes.string
  }),
  capacity: PropTypes.shape({
    name: PropTypes.string,
    abbr: PropTypes.string.isRequired,
    symbol: PropTypes.string
  }),
  distance: PropTypes.shape({
    name: PropTypes.string,
    abbr: PropTypes.string.isRequired,
    symbol: PropTypes.string
  }),
  radius: PropTypes.shape({
    name: PropTypes.string,
    abbr: PropTypes.string.isRequired,
    symbol: PropTypes.string
  })
});

export const userCurrencyPropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number
]);

export const filtersPropType = {
  match: PropTypes.object,
  componentWorking: PropTypes.arrayOf(PropTypes.string),
  facets: PropTypes.shape({
    class: PropTypes.arrayOf(
      PropTypes.shape({
        /** Class slug */
        value: PropTypes.string,
        count: PropTypes.number,
        /** Formatted class name */
        name: PropTypes.string,
        /** Formatted class type name */
        heading: PropTypes.string
      })
    ),
    country: PropTypes.arrayOf(
      PropTypes.shape({
        /** Country initials */
        value: PropTypes.string.isRequired,
        count: PropTypes.number.isRequired
      })
    ),
    fuelType: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
        count: PropTypes.number,
        /** Fuel type slug */
        urlId: PropTypes.string,
        /** Formatted fuel type name */
        name: PropTypes.string,
        heading: PropTypes.string
      })
    ),
    hullMaterial: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
        count: PropTypes.number,
        /** Hull material slug */
        urlId: PropTypes.string,
        /** Formatted hull material name */
        name: PropTypes.string,
        heading: PropTypes.string
      })
    ),
    make: PropTypes.arrayOf(
      PropTypes.shape({
        /** Formatted make name */
        value: PropTypes.string.isRequired,
        count: PropTypes.number.isRequired
      })
    ),
    makeModel: PropTypes.arrayOf(
      PropTypes.shape({
        /** Formatted make name */
        value: PropTypes.string.isRequired,
        count: PropTypes.number.isRequired,
        /** Models list for the make */
        model: PropTypes.arrayOf(
          PropTypes.shape({
            /** Model formatted name */
            value: PropTypes.string.isRequired,
            count: PropTypes.number.isRequired
          })
        )
      })
    ),
    subdivision: PropTypes.arrayOf(
      PropTypes.shape({
        /** State initials */
        value: PropTypes.string.isRequired,
        count: PropTypes.number.isRequired
      })
    )
  }),
  initialState: PropTypes.string,
  mode: PropTypes.any,
  onDataChange: PropTypes.func.isRequired,
  onClearErrors: PropTypes.func,
  position: PropTypes.string,
  cookies: PropTypes.instanceOf(Cookies).isRequired,
  mobileParams: PropTypes.object,
  customUom: PropTypes.shape({
    length: PropTypes.shape({
      name: PropTypes.string,
      abbr: PropTypes.string.isRequired,
      symbol: PropTypes.string
    }),
    weight: PropTypes.shape({
      name: PropTypes.string,
      abbr: PropTypes.string.isRequired,
      symbol: PropTypes.string
    }),
    speed: PropTypes.shape({
      name: PropTypes.string,
      abbr: PropTypes.string.isRequired,
      symbol: PropTypes.string
    }),
    capacity: PropTypes.shape({
      name: PropTypes.string,
      abbr: PropTypes.string.isRequired,
      symbol: PropTypes.string
    }),
    distance: PropTypes.shape({
      name: PropTypes.string,
      abbr: PropTypes.string.isRequired,
      symbol: PropTypes.string
    }),
    radius: PropTypes.shape({
      name: PropTypes.string,
      abbr: PropTypes.string.isRequired,
      symbol: PropTypes.string
    })
  }),
  isThreeColumnLayout: PropTypes.bool,
  userCurrency: PropTypes.string,
  abTestContext: PropTypes.object,
};
